import { createTheme } from '@mui/material';

export const selectStyles = createTheme({
  palette: { primary: { main: '#04a9d2' } },
});
